import {
  IForEachSchemaOptions,
  Schema,
  forEachSchemaNode,
  yup,
} from '@framework/validation';
import { WidgetCompetenceFormSchemaMetaFlag } from './createCompetenceSelectFormSchema';

export function findCompetenceIdInSchema(
  schema: yup.ISchema<any>,
  options: IForEachSchemaOptions,
): string | undefined {
  let competenceId: string | undefined = undefined;
  forEachSchemaNode(schema, options, node => {
    if (
      node.schema instanceof Schema &&
      node.schema.meta?.()?.[WidgetCompetenceFormSchemaMetaFlag] &&
      !node.schema.spec.strip
    ) {
      competenceId = node.value;
      return false;
    }
  });
  return competenceId;
}
